module.exports = __webpack_public_path__ + "static/media/selected_marker_beach.80e53eaf.svg";